import Chart from 'chart.js';
import ChartJSDatalabels from 'chartjs-plugin-datalabels';

Chart.plugins.register(ChartJSDatalabels);
